import { productFamilyIdFormat } from "@redotech/redo-model/ids";
import { ListingTypeSchema } from "@redotech/redo-model/inventory/base-listing";
import * as z from "zod";

export const disableListing = {
  name: "disableListing" as const,
  input: z.object({
    listingType: ListingTypeSchema,
    productFamilyId: productFamilyIdFormat.schema,
  }),
  output: z.object({ success: z.boolean() }),
};
